import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

import CompensationCapacity from './CompensationCapacity'
import NegativeBalance from './NegativeBalance'
import SelectThreshold from './SelectThreshold'
import Threshold from './Threshold'

interface CardContentProps {
  form: TimeoffCompensationForm
  onSubmit: () => void
  hasLimitBalancePool: boolean
}

const CardContent = ({ form, onSubmit, hasLimitBalancePool }: CardContentProps) => {
  const thresholdCapacity = form.get('threshold_capacity')
  const thresholdEnabled = form.get('has_threshold_enabled')
  const thresholdValid =
    !!thresholdEnabled.value && hasLimitBalancePool ? thresholdCapacity.value >= 0 : true
  const showSubmitButton = form.isDirty && thresholdValid

  return (
    <Box paddingX="s8" gap="s24">
      {hasLimitBalancePool && <SelectThreshold field={form.get('has_threshold_enabled')} />}
      {hasLimitBalancePool && <Threshold form={form} />}
      <CompensationCapacity form={form} />
      <NegativeBalance form={form} />
      {showSubmitButton && (
        <Box flexDirection="row" justifyContent="flexEnd">
          <Button onClick={onSubmit}>{i18n.t('common.save')}</Button>
        </Box>
      )}
    </Box>
  )
}

export default observer(CardContent)
